// extracted by mini-css-extract-plugin
module.exports = {"noCardSelected":"NoCardSelected_noCardSelected__bdVLJ","textCenter":"NoCardSelected_textCenter__3xdBu","icon":"NoCardSelected_icon__2YG6z"};